import { render, staticRenderFns } from "./LKMunMehHostViewComment.vue?vue&type=template&id=306ea3a2&"
import script from "./LKMunMehHostViewComment.vue?vue&type=script&lang=js&"
export * from "./LKMunMehHostViewComment.vue?vue&type=script&lang=js&"
import style0 from "./LKMunMehHostViewComment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
